import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

export const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

export function createSlider(viewport, { prev, next, dots = null, speed = 300, modules = [], keyboard = {}, a11y = {}, ...options }) {
    const extra = {};
    if (dots) {
        extra.pagination = {
            el: dots,
            clickable: true,
            renderBullet(index, className) {
                return `<button type="button" class="${className} slider-dots__dot" aria-label="Go to slide ${index + 1}"></button>`;
            },
        };
    }

    return new Swiper(viewport, {
        modules: [Navigation, A11y, Keyboard, ...(dots ? [Pagination] : []), ...modules],
        speed: reducedMotionQuery.matches ? 0 : speed,
        navigation: {
            addIcons: false,
            nextEl: next,
            prevEl: prev,
        },
        keyboard: keyboard === false
            ? { enabled: false }
            : { enabled: true, onlyInViewport: true, ...keyboard },
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            ...(dots ? { paginationBulletMessage: 'Go to slide {{index}}' } : {}),
            slideLabelMessage: null,
            scrollOnFocus: false,
            ...a11y,
        },
        ...extra,
        ...options,
    });
}

export function syncSlides(slides, { visible = false, inertOn = 'slide' } = {}) {
    const list = [...slides];
    const isActive = (slide) => slide.classList.contains('swiper-slide-active');
    const isVisible = (slide) => slide.classList.contains('swiper-slide-visible');
    const anyVisible = visible && list.some(isVisible);
    if (!list.some((slide) => isActive(slide) || (visible && isVisible(slide)))) {
        return;
    }

    list.forEach((slide) => {
        const shown = anyVisible ? isVisible(slide) : isActive(slide);
        slide.setAttribute('aria-hidden', shown ? 'false' : 'true');
        if (inertOn === 'controls') {
            slide.querySelectorAll('a, button').forEach((control) => {
                control.toggleAttribute('inert', !shown);
            });
            return;
        }
        slide.toggleAttribute('inert', !shown);
    });
}
